"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _react2 = require("@emotion/react");
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _reactTracking = require("react-tracking");
var _iconGlobe = _interopRequireDefault(require("../../icons/icon-globe.svg"));
var _languageDirectionAPI = require("../../services/languageDirectionAPI");
var _mediaQuery = _interopRequireDefault(require("../../styles/media-query"));
var _offline = require("../../utilities/offline");
const LocaleSelectContainer = _styled.default.div((0, _mediaQuery.default)({
  alignItems: 'center',
  display: 'flex',
  flexBasis: [null, null, null, '12%'],
  flexDirection: 'row',
  justifyContent: ['center', null, null, 'flex-end'],
  marginInlineStart: [null, null, null, '45px'],
  img: {
    marginInlineEnd: '5px'
  }
}));
const StyledLocaleSelect = _styled.default.select(_ref => {
  let {
    theme
  } = _ref;
  return {
    appearance: 'none',
    background: 'transparent',
    border: 'none',
    color: theme.colors.grey[600],
    cursor: 'pointer',
    fontSize: theme.fontSizes.xxSmall,
    padding: '0px'
  };
});

/**
 * A locale select component that also notifies the user when they are offline.
 */
const LocaleSelect = _ref2 => {
  let {
    i18n
  } = _ref2;
  const {
    trackEvent
  } = (0, _reactTracking.useTracking)();
  const {
    direction
  } = (0, _languageDirectionAPI.useLanguageDirection)();
  const showModalIfOffline = (0, _offline.handleOffline)(() => console.log('you are offline')); // eslint-disable-line no-console
  const theme = (0, _react2.useTheme)();

  /**
   * Reduce the select's width by making it equal to the currently selected text. This allows it to be centered properly.
   * We create a temporary span containing the selected element's text so that we can grab the width.
   */
  const setSelectSize = () => {
    var _document, _document$getElementB, _document$getElementB2;
    const select = document.getElementById('locale-select');
    const tempSpan = document.createElement('span');
    tempSpan.style.visibility = 'hidden';
    tempSpan.style.position = 'absolute';
    tempSpan.textContent = select.options[select.selectedIndex].text;
    tempSpan.id = 'temp-span';
    tempSpan.style.fontSize = theme.fontSizes.xxxSmall;
    select.after(tempSpan);
    const tempSpanWidth = ((_document = document) === null || _document === void 0 ? void 0 : (_document$getElementB = _document.getElementById('temp-span')) === null || _document$getElementB === void 0 ? void 0 : (_document$getElementB2 = _document$getElementB.getBoundingClientRect()) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.width) || 100;
    select.style.width = `${tempSpanWidth + 8}px`;
    tempSpan.remove();
  };
  const handleLocaleChange = event => {
    const ifOnline = () => {
      const select = event.target;
      const newLocale = select.options[select.selectedIndex].value;
      trackEvent({
        event_name: 'locale-selected',
        event_type: 'click',
        newLocale,
        oldLocale: i18n.language
      });
      i18n.changeLocale(newLocale);
      setSelectSize();
    };
    showModalIfOffline(ifOnline);
  };
  (0, _react.useEffect)(() => {
    // Set the inital language on load properly
    i18n.changeLocale(i18n.language);
    setSelectSize();
  }, [i18n.language]); // eslint-disable-line react-hooks/exhaustive-deps

  return /*#__PURE__*/_react.default.createElement(LocaleSelectContainer, null, /*#__PURE__*/_react.default.createElement("img", {
    alt: "Globe Icon",
    src: _iconGlobe.default
  }), /*#__PURE__*/_react.default.createElement(StyledLocaleSelect, {
    "aria-label": "Locale",
    dir: direction,
    id: "locale-select",
    name: "locale",
    value: i18n.language,
    onChange: handleLocaleChange
  }, i18n.locales.map(locale => /*#__PURE__*/_react.default.createElement("option", {
    key: locale.value,
    value: locale.value
  }, locale.display))));
};
var _default = exports.default = LocaleSelect;